import { Outlet, useLocation } from "react-router-dom";

import Navbar from "@/components/Navbar/Navbar";
import { Toaster } from "sonner";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import Footer from "@/components/Footer";
// import useTheme from "@/hooks/stores/useTheme";
// import ThemeToggle from "@/components/ThemToggle";

export function Layout() {
  const location = useLocation();
  
  // Define routes where footer should be shown
  const routesWithFooter = [
    '/about', 
    '/contact', 
    '/Login',
    '/login',
    '/forgot-password',
    '/reset-password',
    '/otp-verification',
    '/users/new'
  ];

  const routesWithoutFooter = ['/form'];
  
  const shouldShowFooter = routesWithFooter.includes(location.pathname) && !routesWithoutFooter.includes(location.pathname);

  // const { theme } = useTheme()
  return (
    <div className="min-h-screen bg-background text-foreground">
      <main className="container-fluid">
        <Outlet />
      </main>
      <AccessibilityWidget />
      {/* <ThemeToggle /> */}
      {/* <Toaster theme={theme} richColors /> */}
      {shouldShowFooter && <Footer />}
    </div>
  );
}